import { Controller, Toolbar } from '@tencent/workbench';
import { TOOLBAR_ITEMS, config } from './config';
import { BrushFeature } from './brush-feature';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

/**
 * 格式刷
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class BrushController {
    constructor(private readonly feature: BrushFeature) {
    }

    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    public onClick() {
        this.feature.onClick();
    }

    @Toolbar(config.id, 'onDoubleClick')
    @Toolbar(wrapIdForBig(config.id), 'onDoubleClick')
    public onDoubleClick() {
        this.feature.onDoubleClick();
    }

    @Toolbar(config.id, 'shouldCheck')
    @Toolbar(wrapIdForBig(config.id), 'shouldCheck')
    public isChecked() {
        return this.feature.isChecked();
    }
}
